export const FATEUNI_LANGUAGE_KEY = 'fateuniLanguage';

/** 写入/更新 fateuniLanguage cookie（365 天，path=/，同域）。
 *  后端 MingliParamCookieInterceptor 与 BaseController.resolveLang 消费此 cookie。 */
export function setFateuniLanguageCookie(lang: string): void {
  document.cookie = `${FATEUNI_LANGUAGE_KEY}=${encodeURIComponent(lang)}; path=/; max-age=31536000; SameSite=Lax`;
}
